// Formatador de data 
export const formatDate = (dateString) => {
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR') + ' - ' +
      date.toLocaleTimeString('pt-BR');
  } catch (error) {
    return dateString;
  }
};

// Formatador para o status da infração
export const formatStatus = (status) => {
  const statusMap = {
    'pending': 'Pendente',
    'confirmed': 'Confirmada',
    'rejected': 'Rejeitada'
  };

  return statusMap[status] || status;
};

// Determina cor do badge baseado no status
export const getStatusColor = (status) => {
  const colorMap = {
    'pending': 'yellow',
    'confirmed': 'green',
    'rejected': 'red'
  };

  return colorMap[status] || 'gray';
};